module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAAx0lEQVQokXXQMUpDQRSF4e+ZaGOZgC4ggopFsFFimVSveRbiW0AqF+Ai3IEouAFbQbAXW0UkjctIlRi08A4kw8tpDmfm594zU5RVbUk93OIUb7jCd7rcsKobDLGNUWTr4N0s76yDjzHI4DP0m+DP6LmsV3w1wXNcYxF5EXmegHbDpHNc4DHflCZ3Y8od3jHBB+7jvAtFWdWXePD/XTMcBnwQvokpxq29/aMXdGJDK3yQ+RZOirKqf7PeP/GW5CudnzO4nXnS0x/0AiP9HEkagwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alarm/personnel-icon.png
// module id = e43S
// module chunks = 1